import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Checkbox, Input } from "expano-components";
import useUpdate from "hooks/useUpdate";
import { Modal } from "components";

const validate = (values) => {
  let errors = {};
  if (!values.name) {
    errors.name = "Pole wymagane";
  }

  return errors;
};

const EditKeywordModal = ({
  id,
  valid,
  pristine,
  handleClose,
  handleSubmit,
  refetch,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/product_group_country_keywords/${id}`,
    onSuccess: () => [refetch(), handleClose()],
    onError: (err) => {
      throw new SubmissionError(err);
    },
  });

  const onSubmit = (values) => update(values);

  return (
    <Modal
      header={{ title: "Aktualizuj slowo kluczowe" }}
      handleClose={handleClose}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="save"
            disabled={!valid || pristine || is_updating}
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <input type="submit" style={{ display: "none" }} />
        <Field label="Nazwa" name="name" component={Input} />
        <Field type="number" label="Wolumen" name="volumen" component={Input} />
        <Field label="Czy tytułowe?" name="is_title" component={Checkbox} />
        <Field label="Czy użyte?" name="is_used" component={Checkbox} />
      </form>
    </Modal>
  );
};

export default reduxForm({
  form: "update-product-group-country-keyword",
  validate,
  enableReinitialize: true,
})(EditKeywordModal);
